import React from 'react';
import Actions from '../../../actions/actions';

function WelcomeCallErrorPage() {
  return (
    <>
      <h3>Your responses have NOT been submitted since your session has expired.</h3>
      <h4>
        Please{' '}
        <button
          onClick={() => {
            sessionStorage.removeItem('WC_JWT_Token');
            Actions.setView('welcomeCall');
            window.location.reload();
          }}
          className={'link-button'}
        >
          click here
        </button>{' '}
        to retry submitting your welcome call{' '}
      </h4>
    </>
  );
}

export default WelcomeCallErrorPage;
